import * as React from 'react';
import Icon from '@ant-design/icons/lib/components/Icon';
const ControlReduce = React.memo((props) => (<Icon component={() => (<svg focusable="false" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16">
        <rect width="12" height="2" x="2" y="7" rx="1"/>
      </svg>)} {...props}/>));
export default ControlReduce;
